import "@aws-amplify/ui-react/styles.css";
import "./index.css";
import { withAuthenticator } from "@aws-amplify/ui-react";
import React, { type FC } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Character } from "./pages/Character";
import { Chat } from "./pages/Chat";
import { ChatRoom } from "./pages/ChatRoom";
import { Home } from "./pages/Home";
import { LLMConfig } from "./pages/LLMConfig";

const App: FC = () => {
  return (
    <>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/characters" element={<Character />} />
          <Route path="/characters/:characterId/chat-rooms" element={<ChatRoom />} />
          <Route path="/characters/:characterId/chat-rooms/:chatRoomId" element={<Chat />} />
          <Route path="/llm-configs" element={<LLMConfig />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default withAuthenticator(App, {
  hideSignUp: true,
});
